export default __webpack_public_path__ + "static/media/logoc3.2ab202d4.png";